import React from 'react';
import ContactForm from '../shared/ContactForm';
import BgTalkUs from '../../assets/imgs/bg-talk-us.webp';
import Title from '../shared/Title';

const ContactUsForm = () => {
  return (
    <div className="xl:px-52 md:px-20 px-10 py-10 text-center bg-cover" style={{ backgroundImage: `url(${BgTalkUs})` }}>
      <Title text1="Contact" text2="Us" isLight={false} colorForText={2} />
      <p className="mb-6 text-dark-blue-900 text-3xl">Have any questions? We’d love to hear from you.</p>
      <ContactForm />
    </div>
  );
};

export default ContactUsForm;
